module.exports = __webpack_public_path__ + "8eb946eca268db43b3c44d8af958d66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/brand/icon200.png
// module id = 111
// module chunks = 4